module.exports = __webpack_public_path__ + "img/scene_6.a524c52e.jpg";